import { render, staticRenderFns } from "./ProviderBox.vue?vue&type=template&id=3a2918c6&scoped=true&"
import script from "./ProviderBox.vue?vue&type=script&lang=ts&"
export * from "./ProviderBox.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderBox.vue?vue&type=style&index=0&id=3a2918c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2918c6",
  null
  
)

export default component.exports